import React, { Dispatch, SetStateAction } from 'react';
import { View, StyleSheet } from 'react-native';
import TabOption from './components/TabOption';
import isMobile from '../../../../IsMobile';

// eslint-disable-next-line no-shadow
export enum UpdateTemplateSection {
  // eslint-disable-next-line no-unused-vars
  MAIN = 'TEMPLATE DATA', ISSUES = 'ISSUES', PPM = 'PPM',
}

interface TabListProps {
  sectionShown: unknown,
  setSectionShown: Dispatch<SetStateAction<unknown>>,
  ppmEnabled: boolean,
  type?: unknown,
  testIDs?: string[],
}

const TabList = ({
  sectionShown, setSectionShown, ppmEnabled, type = UpdateTemplateSection, testIDs = [],
}: TabListProps) => <View style={styles.container}>
    {Object.values(type).map((section: string, index: number) => (
      (section !== UpdateTemplateSection.PPM || ppmEnabled) && <TabOption
        key={`tab_${section}`}
        title={section}
        selected={section === sectionShown}
        onPress={() => setSectionShown(section)}
        testID={testIDs?.[index]}
      />))}
  </View>;

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    marginHorizontal: isMobile ? 16 : 0,
    marginBottom: 8,
    flexWrap: 'wrap',
  },
});

export default TabList;
